import Component from "./ChipSuggest";
import Label from "./components/Label/ChipSuggestLabel";

interface IChipSuggestExtensions {
    Label: typeof Label;
}

export const ChipSuggest: typeof Component & IChipSuggestExtensions =
    Object.assign(Component, {
        Label,
    });
